import { Grid, GridItem, Link, Text } from '@chakra-ui/react'
import type { BoxProps } from '@chakra-ui/react'
import type { FC } from 'react'

import { Button } from '@app/components/ui/button'
import useStoreCurrentUser from '@app/hooks/useStoreCurrentUser'
import CustomerDrawer from '@app/shared/customerDrawer'

const MultiAccountBanner: FC<BoxProps> = ({ ...rest }) => {
  const { user } = useStoreCurrentUser()

  if (!user) {
    return null
  }

  return (
    <Grid as="section" templateColumns="1fr auto 1fr" alignItems="center" py={2} pr={2} pl={4} bg="gray.800" {...rest}>
      <GridItem />
      <GridItem>
        <Text color="white" textAlign="center">
          <Link
            href="https://mixpanel.com/blog/doubleloop-joins-mixpanel"
            color="inherit"
            textDecoration="none"
            _hover={{ textDecoration: 'underline' }}
            target="_blank"
          >
            DoubleLoop is joining Mixpanel!
          </Link>
        </Text>
      </GridItem>
      <GridItem justifySelf="end">
        {user.accountsCount > 1 && (
          <CustomerDrawer>
            <Button bg="gray.600" size="2xs">
              {user?.organization?.name}&nbsp;-&nbsp;Switch accounts
            </Button>
          </CustomerDrawer>
        )}
      </GridItem>
    </Grid>
  )
}

export default MultiAccountBanner
